import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.7035 8.58772C17.64 9.27555 14.9166 9.66667 12 9.66667C9.08343 9.66667 6.35996 9.27555 4.29648 8.58772C3.46874 8.31181 2.6742 7.96429 2 7.52506V11.8301C2 13.671 6.47715 15.1634 12 15.1634C17.5228 15.1634 22 13.671 22 11.8301V7.52506C21.3258 7.96429 20.5313 8.31181 19.7035 8.58772Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 15.0218C21.3258 15.461 20.5313 15.8086 19.7035 16.0845C17.64 16.7723 14.9166 17.1634 12 17.1634C9.08343 17.1634 6.35996 16.7723 4.29648 16.0845C3.46874 15.8086 2.6742 15.461 2 15.0218V19.6666C2 21.5075 6.47715 22.9999 12 22.9999C17.5228 22.9999 22 21.5075 22 19.6666L22 19.6562L22 15.0218Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 7.66667C6.47715 7.66667 2 6.17428 2 4.33333L2 4.33008C2.00528 2.49063 6.48041 1 12 1C16.1421 1 19.6961 1.83947 21.2141 3.03585C21.7202 3.43464 22 3.8731 22 4.33333C22 6.17428 17.5228 7.66667 12 7.66667Z"}}]};

const DataBaseFilled = Vue.extend<IconProps>({
  name: 'DataBaseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'data-base-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DataBaseFilled;
